import * as React from "react";
import type { FluentIcon } from "@fluentui/react-icons";

export interface IIconTextButtonProps {
  icon: FluentIcon;
  iconClassName?: string;
  text?: string;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  tooltip?: string;
  id?: string;
}

const IconTextButton: React.SFC<IIconTextButtonProps> = ({
  icon,
  iconClassName,
  text,
  onClick,
  disabled,
  tooltip,
  id
}) => {
  const renderIcon = () => {
    const disabledClassName = disabled ? "disabledIcon" : undefined;

    const Icon = icon;

    return (
      <Icon
        data-testid="icon-text-btn"
        className={["icon", iconClassName, disabledClassName].filter(Boolean).join(" ")}
        aria-hidden="true"
      />
    );
  };

  return (
    <div
      className={[
        "IconTextButton",
        Boolean(disabled) && "disabled"
      ].filter(Boolean).join(" ")}
      onClick={!disabled ? onClick : undefined}
      title={tooltip}
      aria-label={tooltip}
      role="button"
      aria-disabled={disabled}
      data-testid={id}
    >
      {renderIcon()}
      {text}
    </div>
  );
};

export default IconTextButton;
